export class WebDokuTreeNode {
  public id = "";
  public text = "";
  public children: WebDokuTreeNode[] = [];
}
